import React from 'react'
import './Top.css'
import topimage from '../Images/top.png'
import top1 from '../Images/top1.svg'
import top2 from '../Images/top2.svg'
import top3 from '../Images/top3.svg'
import top4 from '../Images/top4.svg'
import top5 from '../Images/top5.svg'
import top6 from '../Images/top6.svg'
const Top = () => {
    const data = [
        {
            id: 1,
            image: top1,
            title: 'Years of experience in full-stack development',
            para: 'With extensive experience in full-stack technologies, we build scalable, robust, and high-performing web and mobile solutions.'
        },
        {
            id: 2,
            image: top2,
            title: 'Dedicated in-house team',
            para: 'To consistently offer quality and innovation, our talented in-house developers, designers, and strategists work closely together. '
        },
        {
            id: 3,
            image: top3,
            title: 'Transparent process & agile delivery',
            para: 'We follow a clear, step-by-step agile methodology to ensure transparency, flexibility, and timely project delivery.'
        },
        {
            id: 4,
            image: top4,
            title: 'Clients across India, Dubai, and beyond',
            para: 'Trusted by businesses locally and globally, we’ve successfully served clients across India, Dubai, and other international markets.'
        },
        {
            id: 5,
            image: top5,
            title: 'SEO-ready & mobile-first development',
            para: 'Every project is built with a mobile-first approach and optimized for search engines, ensuring visibility and responsiveness.'
        },
        {
            id: 6,
            image: top6,
            title: '24/7 support & maintenance',
            para: 'Our team provides round-the-clock support and maintenance to keep your digital products secure, updated, and running smoothly.'
        }
    ]
    return (
        <div id='top'>
            <div className="section">
                <div className="container">
                    <div className="topLeft">
                        <h1 className='heading'>Why We Are One of The Top Web Development Companies</h1>
                        <div className="imagebox">
                            <img src={topimage} alt="topimage" />
                        </div>
                    </div>
                    <div className="topRight">
                        <div className="topRightContent">
                            {
                                data.map((item) => (
                                    <div className="topRightContentBox" key={item.id}>
                                        <div className="topRightContentBoxImage">
                                            <img src={item.image} alt="topimage" />
                                        </div>
                                        <h2 className="topRightContentBoxTitle">{item.title}</h2>
                                        <p className="topRightContentBoxPara">{item.para}</p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Top